import script from "./AttributeDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./AttributeDetails.vue?vue&type=script&setup=true&lang=js"

import "./AttributeDetails.vue?vue&type=style&index=0&id=40288fb7&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/ignis-pha-production/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40288fb7"]])

export default __exports__